import FarbeTool from "../classes/class_farbetool";
import ToolOptionsFarbe from "./ToolOptionsFarbe.vue";

export let Farbe2 = new FarbeTool('farbe2', 'btn_farbe2', {
        AffectedElements: "w, pc",
        Overlap: true,
    },
    {
        mouseover: {
            Adjacent: true,
        },
        click: {
            Adjacent: false,
        },
    }, {
        //Color: '#5b9bd5',
        Color: '#5B9BD5',
        ColorLight: 'rgba(91, 155, 213, 0.5)',
        CssClass: 'farbe2',
        CssWhenActive: true,
        CssWhenOtherToolsActive: false,
        // box-shadows can be stacked on top of each other
        CssHover: `box-shadow: inset 0 -4px 0 0 rgb(91, 155, 213, 0.5);`,
        CssApplied: `box-shadow: inset 0 -4px 0 0 rgb(91, 155, 213, 1);`,
        CssClassHover: '',
        Cursor: 'custom',
        CursorURL: "/img/editor/cursors/ablabsmarker.png",
        Group: 3,
        Icon: "<img src='/img/svg/hermeneus-btn-farbe2.svg'>",
        Title: 'Farbe 2',
    }, {
        Description:
            `   
            <span class="hermeneus-editor__tool-description bold emphasize">Farbliche Markierung hinzufügen</span>`, Introduction: `
            Markieren Sie Wörter bei gedrückter Maustaste oder durch Klicken farblich. Mit Klick auf 'Fertig' speichern Sie Ihre Auswahl.`,
             ToolOptions: ToolOptionsFarbe
    }, {
        attributes: {
            function: 'ablabs'
        },
        hierarchy: 3,
    });
